var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pt-0 d-flex align-start",
              class: { "mt-md-n10": !_vm.noMarginTop },
              attrs: { cols: "12", sm: "12", md: _vm.showFilters ? 4 : 2 },
            },
            [
              _c(
                "v-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showFilters,
                      expression: "showFilters",
                    },
                  ],
                  staticClass: "pb-2",
                  attrs: { elevation: "0", outlined: "" },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "mx-0 pt-2" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "py-0",
                          attrs: { cols: "12", sm: "12" },
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "pa-0 header-font py-2",
                              staticStyle: { "font-size": "22px" },
                            },
                            [_vm._v(_vm._s(_vm.$t("general.filters")))]
                          ),
                          _vm._v(" "),
                          _vm.currentUser.clientType === "Media" ||
                          _vm.currentUser.clientType === "Driblab"
                            ? _c("MediaModeForm", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showFilters,
                                    expression: "showFilters",
                                  },
                                ],
                                attrs: {
                                  fields: _vm.mediaModeFields,
                                  mediaMode: _vm.mediaMode,
                                  mediaModeData: _vm.mediaModeData,
                                  selectorMode: "",
                                },
                                on: {
                                  mediaModeChange: function ($event) {
                                    return _vm.onMediaModeChange($event)
                                  },
                                  mediaModeDataChange: function ($event) {
                                    return _vm.onMediaModeDataChange($event)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.$vuetify.breakpoint.smAndDown
                        ? _c(
                            "v-col",
                            {
                              staticClass: "d-flex py-1 mb-2 justify-center",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "elevation-0 monospace-font",
                                  attrs: {
                                    color: "primary",
                                    small: "",
                                    outlined: "",
                                    rounded: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.showShotOptions = !_vm.showShotOptions
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.showShotOptions
                                          ? _vm.$t(
                                              "game.detail.hideShotOptions"
                                            )
                                          : _vm.$t(
                                              "game.detail.showShotOptions"
                                            )
                                      ) +
                                      "  "
                                  ),
                                  _c("v-icon", { attrs: { right: "" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.showShotOptions
                                            ? "keyboard_arrow_up"
                                            : "keyboard_arrow_down"
                                        )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "py-0",
                              attrs: { cols: "12", sm: "12" },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "my-0 pa-0 primary--text font-weight-bold body-1 mt-2 mb-1",
                                },
                                [_vm._v(_vm._s(_vm.$t("general.orientation")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "mt-0",
                                  attrs: {
                                    dense: "",
                                    "hide-details": "",
                                    row: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      _vm.xaMap++
                                    },
                                  },
                                  model: {
                                    value: _vm.orientationModel,
                                    callback: function ($$v) {
                                      _vm.orientationModel = $$v
                                    },
                                    expression: "orientationModel",
                                  },
                                },
                                [
                                  _c("v-radio", {
                                    attrs: {
                                      color: _vm.darkMode
                                        ? "secondary darken-2"
                                        : "secondary",
                                      value: "horizontal",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "general.horizontal"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      1570001633
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    attrs: {
                                      color: _vm.darkMode
                                        ? "secondary darken-2"
                                        : "secondary",
                                      value: "vertical",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("general.vertical")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      47682317
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "my-0 pa-0 primary--text font-weight-bold body-1 mt-2",
                                },
                                [_vm._v(_vm._s(_vm.$t("finishingMap.areas")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "elevation-0 monospace-font white--text px-2 my-1",
                                  attrs: {
                                    small: "",
                                    rounded: "",
                                    color: "secondary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onSelectAreaClick()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "white", "x-small": "" },
                                    },
                                    [_vm._v("filter_list")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ms-1" }, [
                                    _vm._v(
                                      _vm._s(
                                        `${_vm.$t(
                                          "areaSelector.filterAreas"
                                        )} (${_vm.areaModel.length}/${
                                          _vm.currentUserAreas.length
                                        })`
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.game
                                ? _c("AreaSelectorModal", {
                                    ref: "areaSelectorModalRef",
                                    attrs: {
                                      title: `${_vm.$t(
                                        "playerDetail.keyPassMap"
                                      )} - ${_vm.$t(
                                        "areaSelector.selectAreas"
                                      )}`,
                                      areaModel: _vm.areaModel,
                                      isVertical: true,
                                    },
                                    on: {
                                      onConfirmClick: function ($event) {
                                        return _vm.onAreaSelectorConfirm($event)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "my-0 pa-0 primary--text font-weight-bold body-1 mt-2",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("finishingMap.typesOfShot"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-autocomplete",
                                {
                                  staticClass: "body-1 mb-4",
                                  attrs: {
                                    items: _vm.shotTypes,
                                    "item-text": "text",
                                    "item-value": "id",
                                    multiple: "",
                                    dense: "",
                                    "hide-details": "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.updateShots()
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "selection",
                                        fn: function ({ item, index }) {
                                          return [
                                            index === 0
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color:
                                                        "lightSecondary lighten-2",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "black--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item.text)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            index === 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "primary--text body-2 subheader-font",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "(+" +
                                                        _vm._s(
                                                          _vm.shotTypeModel
                                                            .length - 1
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "finishingMap.more"
                                                          )
                                                        ) +
                                                        ")"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item",
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 primary--text",
                                              },
                                              [_vm._v(_vm._s(item.text))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    177504760
                                  ),
                                  model: {
                                    value: _vm.shotTypeModel,
                                    callback: function ($$v) {
                                      _vm.shotTypeModel = $$v
                                    },
                                    expression: "shotTypeModel",
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        slot: "prepend-item",
                                        ripple: "",
                                      },
                                      on: { click: _vm.toggleShotTypes },
                                      slot: "prepend-item",
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("finishingMap.selectAll")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    staticClass: "mt-2",
                                    attrs: { slot: "prepend-item" },
                                    slot: "prepend-item",
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "my-0 pa-0 primary--text font-weight-bold body-1 mt-2",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("finishingMap.shotStrategy"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-autocomplete",
                                {
                                  staticClass: "pa-0",
                                  attrs: {
                                    multiple: "",
                                    "hide-details": "",
                                    dense: "",
                                    clearable: "",
                                    items: _vm.shotStrategies,
                                    "item-text": "text",
                                    "item-value": "id",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onStrategyInput()
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "selection",
                                        fn: function ({ item, index }) {
                                          return [
                                            !item.isGroupHeader
                                              ? [
                                                  index === 0
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          staticClass: "my-1",
                                                          attrs: {
                                                            small: "",
                                                            color:
                                                              "lightSecondary lighten-2",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "black--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.text
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : index === 1
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "primary--text body-2 subheader-font",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "(+" +
                                                              _vm._s(
                                                                _vm.shotStrategyModel.filter(
                                                                  (id) =>
                                                                    id !==
                                                                      "group_open" &&
                                                                    id !==
                                                                      "group_set"
                                                                ).length - 1
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "finishingMap.more"
                                                                )
                                                              ) +
                                                              ")"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item",
                                        fn: function ({ item }) {
                                          return [
                                            item.isGroupHeader
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center",
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          small: "",
                                                          color: "secondary",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.isStrategyGroupSelected(
                                                              item.id
                                                            )
                                                              ? "check_box"
                                                              : "check_box_outline_blank"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-2 primary--text font-weight-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.text)
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 primary--text",
                                                  },
                                                  [_vm._v(_vm._s(item.text))]
                                                ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1429827887
                                  ),
                                  model: {
                                    value: _vm.shotStrategyModel,
                                    callback: function ($$v) {
                                      _vm.shotStrategyModel = $$v
                                    },
                                    expression: "shotStrategyModel",
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        slot: "prepend-item",
                                        ripple: "",
                                      },
                                      on: { click: _vm.toggleShotStrategies },
                                      slot: "prepend-item",
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("finishingMap.selectAll")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    staticClass: "mt-2",
                                    attrs: { slot: "prepend-item" },
                                    slot: "prepend-item",
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "my-0 pa-0 primary--text font-weight-bold body-1 mt-2",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("finishingMap.bodyPart"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-autocomplete",
                                {
                                  staticClass: "body-1 mb-4",
                                  attrs: {
                                    items: _vm.bodyParts,
                                    "item-text": "text",
                                    "item-value": "id",
                                    multiple: "",
                                    dense: "",
                                    "hide-details": "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.updateShots()
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "selection",
                                        fn: function ({ item, index }) {
                                          return [
                                            index === 0
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color:
                                                        "lightSecondary lighten-2",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "black--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item.text)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            index === 1
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "primary--text body-2 subheader-font",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "(+" +
                                                        _vm._s(
                                                          _vm.bodyPartModel
                                                            .length - 1
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "finishingMap.more"
                                                          )
                                                        ) +
                                                        ")"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item",
                                        fn: function ({ item }) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 primary--text",
                                              },
                                              [_vm._v(_vm._s(item.text))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1154278695
                                  ),
                                  model: {
                                    value: _vm.bodyPartModel,
                                    callback: function ($$v) {
                                      _vm.bodyPartModel = $$v
                                    },
                                    expression: "bodyPartModel",
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        slot: "prepend-item",
                                        ripple: "",
                                      },
                                      on: { click: _vm.toggleBodyPart },
                                      slot: "prepend-item",
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("finishingMap.selectAll")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    staticClass: "mt-2",
                                    attrs: { slot: "prepend-item" },
                                    slot: "prepend-item",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "py-1",
                              attrs: { cols: "12", sm: "12" },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "my-0 pa-0 primary--text font-weight-bold body-1 mt-2",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("game.gamePossessionMap.time")
                                    )
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-wrap pt-0 pb-1",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("v-checkbox", {
                                staticClass: "px-1 py-0 ma-0",
                                attrs: {
                                  label: _vm.$t("general.firstHalf"),
                                  color: "secondary",
                                  value: "period1",
                                  "hide-details": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.updateShots()
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-1 primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("general.firstHalf")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3581771750
                                ),
                                model: {
                                  value: _vm.periods,
                                  callback: function ($$v) {
                                    _vm.periods = $$v
                                  },
                                  expression: "periods",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                staticClass: "px-1 py-0 ma-0",
                                attrs: {
                                  label: _vm.$t("general.secondHalf"),
                                  color: "secondary",
                                  value: "period2",
                                  "hide-details": "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.updateShots()
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "body-1 primary--text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("general.secondHalf")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1931206316
                                ),
                                model: {
                                  value: _vm.periods,
                                  callback: function ($$v) {
                                    _vm.periods = $$v
                                  },
                                  expression: "periods",
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasFirstOT
                                ? _c("v-checkbox", {
                                    staticClass: "px-1 py-0 ma-0",
                                    attrs: {
                                      label: _vm.$t("general.firstPeriodOT"),
                                      color: "secondary",
                                      value: "period3",
                                      "hide-details": "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.updateShots()
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "general.firstPeriodOT"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      2642105819
                                    ),
                                    model: {
                                      value: _vm.periods,
                                      callback: function ($$v) {
                                        _vm.periods = $$v
                                      },
                                      expression: "periods",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasSecondOT
                                ? _c("v-checkbox", {
                                    staticClass: "px-1 py-0 ma-0",
                                    attrs: {
                                      label: _vm.$t("general.secondPeriodOT"),
                                      color: "secondary",
                                      value: "period4",
                                      "hide-details": "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.updateShots()
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "general.secondPeriodOT"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      1873983217
                                    ),
                                    model: {
                                      value: _vm.periods,
                                      callback: function ($$v) {
                                        _vm.periods = $$v
                                      },
                                      expression: "periods",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showShotOptions
                        ? _c(
                            "v-col",
                            {
                              staticClass: "d-flex pt-1 pb-2 mb-5",
                              attrs: { cols: "12", sm: "12" },
                            },
                            [
                              _c("v-range-slider", {
                                staticClass: "align-center py-0",
                                attrs: {
                                  "thumb-label": "",
                                  max: _vm.minutesMax,
                                  min: _vm.minutesMin,
                                  step: "1",
                                  "hide-details": "",
                                  color: `secondary ${
                                    _vm.$vuetify.theme.dark ? "lighten-3" : ""
                                  }`,
                                },
                                on: { input: _vm.updateShots },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex flex-column",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "primary--text font-weight-bold body-1",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "finishingMap.minutes"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 subheader-font monospace-font",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      `(${_vm.minutesMin} - ${_vm.minutesMax})`
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2174348164
                                ),
                                model: {
                                  value: _vm.minutes,
                                  callback: function ($$v) {
                                    _vm.minutes = $$v
                                  },
                                  expression: "minutes",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "px-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-end pt-2 pb-1 px-2",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.saveAsPNG()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("\n                file_download")]
                              ),
                              _vm._v(" "),
                              _c("span", {}, [_vm._v("PNG")]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.saveAsSVG()
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("file_download"),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("SVG")]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                                loading: _vm.loadingExport,
                                disabled: !_vm.chartSize,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.onGenerateIFrameClick()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("share")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Embed")]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-shrink-0 ml-2 align-self-start" },
                [_vm._t("filters-toggle")],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              ref: "chart",
              staticClass: "text-center pt-0",
              attrs: {
                cols: "12",
                sm: "12",
                md: _vm.showFilters ? 8 : 10,
                id: "chart",
              },
            },
            [
              _vm.avatarSize && _vm.mediaMode && _vm.game
                ? _c("GameAvatarMedia", {
                    ref: "gameAvatarMediaRef",
                    attrs: {
                      width: _vm.avatarSize.width,
                      height: _vm.avatarSize.height,
                      id: `${_vm.gameId}-${_vm.chartId}`,
                      game: _vm.game,
                      margin: _vm.margin,
                      titleLeft: _vm.isMobile
                        ? _vm.game.homeTeamAlias
                        : _vm.game.homeTeamName,
                      titleRight: _vm.isMobile
                        ? _vm.game.awayTeamAlias
                        : _vm.game.awayTeamName,
                      leftColor: _vm.isWhite(_vm.mediaModeData.leftFillColor)
                        ? _vm.mediaModeData.leftBorderColor
                        : _vm.mediaModeData.leftFillColor,
                      rightColor: _vm.isWhite(_vm.mediaModeData.rightFillColor)
                        ? _vm.mediaModeData.rightBorderColor
                        : _vm.mediaModeData.rightFillColor,
                      bgColor: _vm.mediaModeData.bgColor,
                      textColor: _vm.mediaModeData.textColor,
                      type: "keyPassMap",
                      lineDistance: _vm.mediaModeData.lineLength,
                      avatarSize: _vm.mediaModeData.avatarSize,
                      lineWeight: _vm.mediaModeData.lineWeight,
                      titleFontSize: _vm.mediaModeData.titleFontSize,
                      titleFontWeight: _vm.mediaModeData.titleFontWeight,
                      subtitle: _vm.mediaModeData.subtitle,
                      subtitleFontSize: _vm.mediaModeData.subtitleFontSize,
                      subtitleFontWeight: _vm.mediaModeData.subtitleFontWeight,
                      subtitle2: _vm.mediaModeData.subtitle2,
                      subtitle2FontSize: _vm.mediaModeData.subtitle2FontSize,
                      subtitle2FontWeight:
                        _vm.mediaModeData.subtitle2FontWeight,
                      isVertical: _vm.orientationModel === "vertical",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.size != 0 && _vm.game !== null && _vm.shots.length > 0
                ? _c("XAChart", {
                    key: _vm.xaMap,
                    attrs: {
                      size: _vm.size,
                      type: _vm.type,
                      game: _vm.game,
                      passes: _vm.filteredShots,
                      language: _vm.currentUserLanguage,
                      homeFillColor: _vm.mediaModeData.leftFillColor,
                      awayFillColor: _vm.mediaModeData.rightFillColor,
                      homeBorderColor: _vm.mediaModeData.leftBorderColor,
                      awayBorderColor: _vm.mediaModeData.rightBorderColor,
                      homeTeamName: _vm.mediaModeData.titleLeft,
                      awayTeamName: _vm.mediaModeData.titleRight,
                      mediaMode: _vm.mediaMode,
                      id: `${_vm.gameId}-${_vm.chartId}`,
                      filterShotTypeText: _vm.filterShotTypeText,
                      filterShotStrategyText: _vm.filterShotStrategyText,
                      filterBodyPartText: _vm.filterBodyPartText,
                      filterTimeText: _vm.filterTimeText,
                      orientation: _vm.orientationModel,
                    },
                    on: {
                      sizeChange: function ($event) {
                        return _vm.onChartSizeChange($event)
                      },
                      loaded: function ($event) {
                        return _vm.onLoaded($event)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.game &&
              _vm.avatarSize &&
              _vm.size &&
              _vm.mediaMode &&
              _vm.mediaModeData.socialMedia
                ? _c("DriblabSocialMedia", {
                    ref: "driblabSocialMediaRef",
                    attrs: {
                      width: _vm.avatarSize.width,
                      height: 50,
                      id: `${_vm.gameId}-${_vm.chartId}`,
                      margin: _vm.margin,
                      bgColor: _vm.mediaModeData.bgColor,
                      textColor: _vm.mediaModeData.textColor,
                      fontSize: _vm.mediaModeData.socialMediaFontSize,
                      fontWeight: _vm.mediaModeData.socialMediaFontWeight,
                      logoCfg: _vm.mediaModeData.logo,
                      sponsor: _vm.mediaModeData.sponsor.dataUrl,
                      type: "finishingMap",
                      isVertical: _vm.orientationModel === "vertical",
                      isGame: true,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.game
        ? _c("ChartExportLinksModal", {
            ref: "chartExportLinksModalRef",
            attrs: {
              title: `${_vm.game.homeTeamName} ${_vm.game.homeTeamScore} - ${_vm.game.awayTeamScore} ${_vm.game.awayTeamName}`,
              subtitle: _vm.$t("playerDetail.keyPassMap"),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }